import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import TabsPage from '../views/TabsPage.vue';
import { AuthLib, LoginPage } from 'vue-app-auth-lib';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login-page',
    component: LoginPage,
    props: {
        buttonColor: "green",
    },
  },
  {
    path: '/',
    component: TabsPage,
    meta: {
      middleware: [AuthLib.authLibMiddleware]
    },
    children: [
      {
        path: '/',
        redirect: '/home-page'
      },
      {
        path: '/home-page',
        component: () => import('@/views/HomePage.vue')
      },
      {
        path: '/contracts-page',
        component: () => import('@/views/ContractsPage.vue')
      },
      {
        path: '/settings-page',
        component: () => import('@/views/SettingsPage.vue'),
      },
      {
        path: '/help-page',
        component: () => import('@/views/HelpPage.vue')
      }
    ]
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
});

export default router
